 /**
  * Extra
  **/
 jQuery(document).ready(function() {
     // item
    //  if ($('.prestaItem').length) {
    //      $('.prestaItem').each(function() {
    //          var $this = $(this);
    //          var id = $this.data("id");
    //          var template = $this.data("template");
    //          var showdispo = $this.data("showdispo");
    //          var showtarif = $this.data("showtarif");
    //          var lg = $this.data("lang");
    //          Apidae_Util.ajaxSend($this);

    //          $.ajax({
    //              url: base_url + '/services/getPrestaItem',
    //              type: 'GET',
    //              data: { idPrestation: id, templateDetail: template, showDispo: showdispo, showTarif: showtarif, lang: lg }
    //          }).done(function(data) {
    //              $this.append(data);
    //              Apidae_Util.ajaxComplete($this);
    //          });
    //      });
    //  }

     // home event
     if ($('#HomeEventSlide').length) {
         var $this = $('#HomeEventSlide');
         var type = $this.data("type");
         var nb = $this.data("nb");
         var lang = $this.data("lang");
         var date = $this.data("date");
         var href = $this.data("url") + '/slider?type=' + type + '&nb=' + nb + '&lang=' + lang + '&date=' + date;
         Apidae_Util.ajaxSend('#HomeEventSlide');

         $.get(href, function(data) {
             $('#HomeEventSlide').append(data);
             Apidae_Util.ajaxComplete('#HomeEventSlide');
         });
     }

     // slide
     // <div class="prestasSlider" data-url="http://www.fmz.local/fr/animation" data-type="slideEvent" data-filter="filter1826=31" data-nb="16" data-lang="fr">&nbsp;</div>
     if ($('.prestasSlider').length) {
         $('.prestasSlider').each(function() {
             var $this = $(this);
             var filter = $this.data("filter");
             var type = $this.data("type");
             var nb = $this.data("nb");
             var lang = $this.data("lang");
             var date = $this.data("date");
             var href = $this.data("url") + '/slider?type=' + type + '&nb=' + nb + '&lang=' + lang + '&date=' + date + '&' + filter;
             Apidae_Util.ajaxSend($this);

             $.get(href, function(data) {
                 $($this).append(data);
                 $('.slider-prestas').bxSlider({
                     slideWidth: 196,
                     slideMargin: 4,
                     minSlides: 1,
                     maxSlides: 10,
                     moveSlides: 1,
                     nextSelector: '#slider-next',
                     prevSelector: '#slider-prev',
                     nextText: '<i class="fa-thin fa-2x fa-chevron-right"></i>',
                     prevText: '<i class="fa-thin fa-2x fa-chevron-left"></i>',
                     pager: false,
                     auto: false
                 });
                 Apidae_Util.ajaxComplete($this);
             });
         });
     }

     // slideShow
     if ($('#prestasSliderKiosk').length) {
         var $this = $('#prestasSliderKiosk');
         var type = $this.data("type");
         var nb = $this.data("nb");
         var lang = $this.data("lang");
         var date = $this.data("date");
         var href = $this.data("url") + '/slider?type=' + type + '&nb=' + nb + '&lang=' + lang + '&date=' + date;
         Apidae_Util.ajaxSend('#prestasSliderKiosk');

         $.get(href, function(data) {
             $('#prestasSliderKiosk').append(data);
             $('.slider_kiosk').bxSlider({
                 speed: 2000,
                 slideWidth: 500,
                 minSlides: 2,
                 maxSlides: 2,
                 moveSlides: 1,
                 slideMargin: 30,
                 auto: true,
                 controls: false,
                 pager: false,
                 easing: 'ease-in'
             });
             Apidae_Util.ajaxComplete('#prestasSliderKiosk');
         });
     }

     // related
    //  if ($('.Presta').length) {
    //      var $this = $('#related');
    //      var date = $this.data("date");
    //      var href = $this.attr("content") + '/related?date=' + date;
    //      Apidae_Util.ajaxSend('#related');

    //      $.get(href, function(data) {
    //          $('#related').append(data);
    //          $('#slider-related').owlCarousel({
    //              loop: true,
    //              margin: 10,
    //              nav: true,
    //              navText: ['<i class="fa-thin fa-2x fa-arrow-circle-left"></i>', '<i class="fa-thin fa-2x fa-arrow-circle-right"></i>'],
    //              responsive: {
    //                  0: {
    //                      items: 1
    //                  },
    //                  600: {
    //                      items: 3
    //                  },
    //                  1000: {
    //                      items: 5
    //                  },
    //                  1600: {
    //                      items: 7
    //                  }
    //              }
    //          });
    //          Apidae_Util.ajaxComplete('#related');
    //      });
    //  }
 });